/* eslint-disable consistent-return */
import { useEffect } from 'react';

function useDisableSwiping(ref) {
  useEffect(() => {
    const targetElement = ref.current;

    if (!targetElement) {
      return;
    }

    const handleTextFieldSwipe = event => {
      event.stopPropagation();
    };

    targetElement.addEventListener('touchmove', handleTextFieldSwipe);

    return () => {
      targetElement.removeEventListener('touchmove', handleTextFieldSwipe);
    };
  });
}

export default useDisableSwiping;
